import DomToImage from "dom-to-image";

/**
 * Puts a PNG of the table on the clipboard, at full length rather than just
 * the part scrolled into view. Throws if the render or the clipboard write
 * fails.
 */
export const copyTableImage = async (table: HTMLTableElement) => {
  // Cell backgrounds are mostly transparent, so the image takes the card
  // color. Otherwise it pastes as text floating on whatever is behind it.
  const bgcolor = getComputedStyle(table)
    .getPropertyValue("--surface-card")
    .trim();
  // Safari only honors a clipboard write started inside the click, so the
  // item is handed the pending render instead of awaiting it first.
  const png = DomToImage.toBlob(table, {
    bgcolor,
    filter: (node: Node) =>
      !(node instanceof Element && node.matches("[data-capture-hide]")),
  });
  await navigator.clipboard.write([new ClipboardItem({ "image/png": png })]);
};
